import { useState, useEffect } from 'react';

export default function usePlacesAutocomplete(inputRef, options = {}) {
    const [autocomplete, setAutocomplete] = useState(null);

    useEffect(() => {
        if (!window.google || !inputRef.current || autocomplete) return;

        const ac = new window.google.maps.places.Autocomplete(
            inputRef.current,
            // no more types:['(regions)'] – we’ll allow everything
            {
                // you can still restrict by country/region if you want:
                // componentRestrictions: { country: 'us' },
                ...options
            }
        );

        // if the caller passed `fields`, register them here so
        // getPlace() returns exactly what we need
        if (options.fields) {
            ac.setFields(options.fields);
        }

        setAutocomplete(ac);
    }, [inputRef, options, autocomplete]);

    return autocomplete;
}
